export const getLocation = () => {
	return window.location != window.parent.location
		? document.referrer
		: window.location.href;
};
